export class ObjSearchDB {
	desc: string; /* campo utilizzato per la costruzione della where */
	where: string;
	where2: string;
	orderBy: string;
	pagina: number;
	righePagina: number;
	totRighe: number;
	categoria: number;
	creato_da_sopralluogo: number;
	preventivo_caricato: number;
	richiede_preventivo: number;
	cnt_applicativo: string;

	/*    constructor() {
          this.orderBy = '';
          /*this.where = '';
          this.pagina = 1;
          this.righePagina = 20;
          this.totRighe = 0;
      }*/

	/* MI
non cambiare i valori del costruttore!!!!
si possono cambiare solo 'righePagina' e 'totRighe'
*/
	constructor() {
		this.desc = '';
		this.where = '';
		this.where2 = '';
		this.orderBy = '';
		this.pagina = 1;
		this.righePagina = 20;
		this.totRighe = 0;
		this.categoria = 0;
		this.creato_da_sopralluogo = 0;
		this.preventivo_caricato = 0;
		this.richiede_preventivo = 0;
		this.cnt_applicativo = '';
	}
}
